module.exports = __webpack_public_path__ + "static/media/survey_icon.63658be2.svg";